import { create } from 'zustand';
import { useCodexStore } from '@/stores/codexStore';
import { buildCanonBundle } from './canonBundle';
import { isTauriRuntime, mirrorCanonThroughTauri } from './tauriBridge';
import { checksumOf } from '@/lib/hash';

/**
 * 미러 동기화 단일 소유자(K5-f) — 디바운스 훅과 전송 전 flush가 같은 경로·같은 해시 캐시를 쓴다.
 * 감사 P1 해소 2건: ①실패 무성 처리 → 상태로 노출(+5s 1회 재시도) ②flush-before-send 핸드셰이크 제공.
 */
interface MirrorStatusState {
  error: string | null;
  lastOkAt: number | null;
}
export const useMirrorStatus = create<MirrorStatusState>(() => ({ error: null, lastOkAt: null }));

let lastHash = '';
let retryTimer: ReturnType<typeof setTimeout> | null = null;

/** 즉시 미러 동기화(디바운스 우회) — 무변경이면 스킵(true). 실패면 상태 노출 + 5초 뒤 1회 재시도, false. */
export async function mirrorNow(): Promise<boolean> {
  if (!isTauriRuntime()) return false;
  const s = useCodexStore.getState();
  if (!s.project) return false;
  const bundle = buildCanonBundle({
    project: s.project,
    entities: Object.values(s.entities),
    links: Object.values(s.links),
    generatedAt: 0, // 내용 동일 = 해시 동일(무변경 스킵)
  });
  const hash = checksumOf(bundle);
  if (hash === lastHash) return true;
  try {
    await mirrorCanonThroughTauri(bundle, hash);
    lastHash = hash;
    useMirrorStatus.setState({ error: null, lastOkAt: Date.now() });
    return true;
  } catch (err) {
    useMirrorStatus.setState({ error: err instanceof Error ? err.message : String(err) });
    if (!retryTimer) {
      retryTimer = setTimeout(() => {
        retryTimer = null;
        void mirrorNow();
      }, 5000);
    }
    return false;
  }
}
